import { Record } from 'immutable';

/* eslint-disable import/prefer-default-export */
export const StateModal = Record({
  isVisible: true,
})
